var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('vue-json-editor',{attrs:{"modes":_vm.modes,"mode":_vm.mode,"expanded-on-start":true},on:{"json-change":_vm.onJsonChange,"has-error":_vm.onError,"json-save":_vm.onJsonSave},model:{value:(_vm.resultInfo),callback:function ($$v) {_vm.resultInfo=$$v},expression:"resultInfo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }